
import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import Blog from '@/layouts/blog';
import Content from './content/content';
import { articleDetailType } from './typing';

function BlogDetail(props: { article: articleDetailType; channelName: string }) {
  const { channelName } = props;
  return (
    <div>
      <Blog selected={channelName} />
      {/* backgroundColor: '#f7f7f7' */}
      <div style={{ backgroundColor: '#fff' }}>
        <Content {...props} />
      </div>
    </div>
  );
}

//  window.__pageInitData  里面有文章详情具体值
BlogDetail.defaultProps = {
  // eslint-disable-next-line
  article: window.__pageInitData,
  // eslint-disable-next-line react/default-props-match-prop-types
  channelName: window.__channelName,
};
ReactDOM.render(<BlogDetail />, document.getElementById('root'));

  